/**
 * NIKA: Algolia Insights events — тренират Recommend моделите.
 * - view: разглеждане на продуктова страница
 * - conversion (addToCart): добавяне в количката
 * Анонимен userToken в localStorage (1 година). Изпращането е batch-нато
 * и никога не блокира UI-а; при грешка мълчи (аналитиката не е критична).
 */
const CFG = window.NIKA_ALGOLIA;

const TOKEN_KEY = 'nika-alg-token';

function userToken() {
  try {
    let t = localStorage.getItem(TOKEN_KEY);
    if (!t) {
      t = 'anon-' + Math.random().toString(36).slice(2) + Date.now().toString(36);
      localStorage.setItem(TOKEN_KEY, t);
    }
    return t;
  } catch (e) {
    return 'anon-session';
  }
}

function sendEvents(events) {
  if (!CFG || !events.length) return;
  const payload = JSON.stringify({ events });
  const url = `https://insights.algolia.io/1/events?x-algolia-application-id=${CFG.appId}&x-algolia-api-key=${CFG.searchKey}`;
  fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: payload,
    keepalive: true,
  }).catch(() => {
    if (navigator.sendBeacon) {
      navigator.sendBeacon(url, new Blob([payload], { type: 'application/json' }));
    }
  });
}

function baseEvent(extra) {
  return {
    index: CFG.index,
    userToken: userToken(),
    timestamp: Date.now(),
    ...extra,
  };
}

/* Изложено за другите NIKA скриптове (търсачката праща click events) */
window.NIKA_ALGOLIA_SEND = (events) => sendEvents(events.map((e) => baseEvent(e)));

/* 1) Разглеждане на продукт */
if (CFG?.productObjectID) {
  sendEvents([
    baseEvent({
      eventType: 'view',
      eventName: 'Product Viewed',
      objectIDs: [String(CFG.productObjectID)],
    }),
  ]);
}

/* 2) Добавяне в количката — прихваща submit на всяка add-to-cart форма
   (главната на продукта + quick-add в категориите) */
document.addEventListener(
  'submit',
  (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!(form.action || '').includes('/cart/add')) return;
    const variantId = form.querySelector('[name="id"]')?.value;
    if (!variantId) return;
    /* ако добавянето идва след търсене (клик от модала в последните 30 мин),
       пращаме conversion с queryID — храни Dynamic Re-Ranking */
    let queryID = null;
    try {
      const last = JSON.parse(sessionStorage.getItem('nika-alg-click') || 'null');
      if (last && Date.now() - last.ts < 30 * 60 * 1000) {
        /* съвпадение по вариант ИЛИ по продукт (handle) — потребителят
           често сменя варианта на продуктовата страница */
        const pageHandle = location.pathname.includes('/products/')
          ? location.pathname.split('/products/')[1]?.split(/[/?#]/)[0]
          : null;
        if (last.objectID === String(variantId) || (last.handle && last.handle === pageHandle)) {
          queryID = last.queryID;
        }
      }
    } catch (e) { /* ignore */ }
    sendEvents([
      baseEvent({
        eventType: 'conversion',
        eventSubtype: 'addToCart',
        eventName: queryID ? 'Product Added To Cart After Search' : 'Product Added To Cart',
        objectIDs: [String(variantId)],
        ...(queryID ? { queryID } : {}),
      }),
    ]);
  },
  { capture: true }
);
